import { GenIcon } from '../lib/iconBase.js';
import '../lib/iconContext.js';

// THIS FILE IS AUTO GENERATED
function IoOpenOutline (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M384 224v184a40 40 0 0 1-40 40H104a40 40 0 0 1-40-40V168a40 40 0 0 1 40-40h167.48M336 64h112v112M224 288 440 72"},"child":[]}]})(props);
}

export { IoOpenOutline };
//# sourceMappingURL=index.js.map
